import Table from 'components/table/table';
import EmptyState from '../../../components/EmptyState/EmptyState';
import { useOutletContext } from 'react-router-dom';

const PayslipContent = () => {
  const {
    payslipsToDisplay,
    currentPage,
    setCurrentPage,
    totalPages,
    countPerPage,
    countTotal,
    isWaiting,
    selectedIds,
    setSelectedIds,
    filteredPayslips,
  } = useOutletContext();

  const allFilteredIds = filteredPayslips?.map((p) => p.id_temp_worker_bestt) || [];
  const allChecked = allFilteredIds.length > 0 && allFilteredIds.every((id) => selectedIds.includes(id));
  const someChecked = !allChecked && allFilteredIds.some((id) => selectedIds.includes(id));

  const handleToggleAll = () => {
    if (allChecked) {
      setSelectedIds([]);
    } else {
      setSelectedIds(allFilteredIds);
    }
  };

  const titles = [
    '',
    'ID BESTT',
    'NOM / PRÉNOM',
    'DATE',
    'MONTANT',
    'STATUT',
    'ACTION',
  ];

  return (
    <div className="flex flex-col gap-3 flex-1 min-h-0">
      {isWaiting ? (
        <table className="animate-pulse w-full">
          <tbody>
            {[1, 2, 3, 4, 5].map((_, idx) => (
              <tr key={idx}>
                {titles.map((_, j) => (
                  <td key={j} className="px-2 py-7">
                    <div className="h-2 bg-gray-200 rounded" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : payslipsToDisplay?.length > 0 ? (
        <>
          <div className="flex items-center gap-2 px-2 text-sm text-gray-600">
            <input
              type="checkbox"
              checked={allChecked}
              ref={(el) => { if (el) el.indeterminate = someChecked; }}
              onChange={handleToggleAll}
            />
            <span>
              {allChecked
                ? `Tout désélectionner (${allFilteredIds.length})`
                : selectedIds.length > 0
                  ? `${selectedIds.length} sélectionné(s) — Tout sélectionner (${allFilteredIds.length})`
                  : `Tout sélectionner (${allFilteredIds.length})`
              }
            </span>
          </div>
          {/* The table is h-full: alone under the select-all line it would
              take the whole tab and push the page into a second scroll. Here
              it gets what is left, and only its list scrolls. */}
          <div className="flex-1 min-h-0">
            <Table
              champsBody={payslipsToDisplay}
              champsHeader={titles}
              currentPage={currentPage}
              countPerPage={countPerPage}
              countTotal={countTotal}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </>
      ) : (
        <EmptyState type="payslip" />
      )}
    </div>
  );
};

export default PayslipContent;
